import React from 'react'

const AnimeContainer = () => {
  return (
    <div>AnimeContainer</div>
  )
}

export default AnimeContainer